import { SWReactIcons } from "@similarweb/icons";
import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";

type Props = {
    quota: number;
    withLegacyQuotaView: boolean;
    defaultText: string;
};

const InfoTooltip = ({ quota, withLegacyQuotaView, defaultText }: Props) => {
    const trigger = (
        <SWReactIcons
            iconName="info"
            size="xs"
        />
    );

    if (withLegacyQuotaView) {
        const { key, replacements } = quotaKeys.noExportQuotaLeftForMonth({ quota });
        return (
            <Tooltip
                placement="top"
                content={translate(key, replacements)}
            >
                {trigger}
            </Tooltip>
        );
    }

    return (
        <Tooltip
            placement="top"
            content={defaultText}
        >
            {trigger}
        </Tooltip>
    );
};

export default InfoTooltip;
